import * as svg from "../../../assets/calendar-outline-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CalendarOutlineIcon = iconBuilder(svg, "CalendarOutlineIcon", "0 0 21 21");
